import React from 'react';
import styles from './TableContent.module.scss';
import { XPagination } from '@/components/xqxc_ui';
import { Table } from 'antd';
import PropTypes from 'prop-types';
import { tooltipStyle, tooltip, cellWidth, tooltipClick, priceFenToYuanCell } from '@/components/TableCell';

class TableContent extends React.Component {

    _columns = () => [
        {
            title: '手机号码',
            dataIndex: 'tel',
            key: 'tel',
            width: '15%',
            align: 'center',
            onCell: tooltipStyle,
            render: (text, record) => tooltipClick(text, () => { this.props.tableAction('detail', record); })
        },
        {
            title: '企业名称',
            dataIndex: 'epName',
            key: 'epName',
            width: '15%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '绑定小运力数',
            dataIndex: 'smalltransportCount',
            key: 'smalltransportCount',
            width: '15%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '关联区域数',
            dataIndex: 'zoneCount',
            key: 'zoneCount',
            width: '15%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '非区域单运费模板',
            dataIndex: 'epDeliveryFeeRuleName',
            key: 'epDeliveryFeeRuleName',
            width: '15%',
            align: 'center',
            onCell: tooltipStyle,
            render: (text, record) => tooltipClick(text, () => { this.props.tableAction('templateDetail', record); })
        },
        {
            title: '预付款',
            dataIndex: 'remainBalance',
            key: 'remainBalance',
            width: '80px',
            align: 'center',
            onCell: tooltipStyle,
            render: priceFenToYuanCell
        },
        {
            title: '状态',
            dataIndex: 'statusStr',
            key: 'statusStr',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '注册时间',
            dataIndex: 'epRegisterTime',
            key: 'epRegisterTime',
            width: '15%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'action',
            width: '25%',
            key: 'action',
            align: 'center',
            render: (id, item) => this._TableAction(item)
        },
    ];

    OC_columns = () => [
        {
            title: '手机号码',
            dataIndex: 'tel',
            key: 'tel',
            width: '15%',
            align: 'center',
            onCell: tooltipStyle,
            render: (text, record) => tooltipClick(text, () => { this.props.tableAction('detail', record); })
        },
        {
            title: '企业名称',
            dataIndex: 'epName',
            key: 'epName',
            width: '15%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '运费模板',
            dataIndex: 'epDeliveryFeeRuleName',
            key: 'epDeliveryFeeRuleName',
            width: '15%',
            align: 'center',
            onCell: tooltipStyle,
            render: (text, record) => tooltipClick(text, () => { this.props.tableAction('templateDetail', record); })
        },
        {
            title: '预付款',
            dataIndex: 'remainBalance',
            key: 'remainBalance',
            width: '80px',
            align: 'center',
            onCell: tooltipStyle,
            render: priceFenToYuanCell
        },
        {
            title: '状态',
            dataIndex: 'statusStr',
            key: 'statusStr',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '注册时间',
            dataIndex: 'epRegisterTime',
            key: 'epRegisterTime',
            width: '15%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'action',
            width: '25%',
            key: 'action',
            align: 'center',
            render: (id, item) => this._TableAction(item)
        },
    ];

    _takeDataSource = (data) => {
        if (Array.isArray(data)) {
            return data;
        } else {
            return [];
        }
    }

    _TableAction = (record) => {
        const { tableAction } = this.props;
        // // 当为禁用或拉黑时，显示为'启用'
        const disable = record.status == 'DISABLE' || record.status == 'BLACK' ? true : false;
        const codeStatus = record.pickupCodeStatus == '1' ? false : true;

        // 取件码
        const pullStatus = record.receiveCodeStatus == '1' ? false : true;

        return (
            <div className={styles.action}>
                <div className={styles.item} onClick={() => tableAction('detail', record)}>查看详情</div>
                <div className={styles.item} onClick={() => tableAction('template', record)}>设置运费模板</div>
                <div className={styles.item} onClick={() => tableAction('available', record)}>{disable ? '启用' : '禁用'}</div>
                <div className={styles.item} onClick={() => tableAction('takecode', record)}>{codeStatus ? '启用取件码' : '禁用取件码'}</div>
                <div className={styles.item} onClick={() => tableAction('pullcode', record)}>{pullStatus ? '启用收件码' : '禁用收件码'}</div>
            </div>
        );
    };

    render() {
        const { paginationChange, rowSelection } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;

        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    columns={process.env.TYPE == 'OC' ? this.OC_columns() : this._columns()}
                    // columns={this._columns()}
                    rowSelection={rowSelection}
                    rowKey={(r) => r.userId}
                    dataSource={this._takeDataSource(dataList)}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

TableContent.propTypes = {
    rowSelection: PropTypes.object,
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
};
export default TableContent;

